import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "45px",
  },
}));
